import React, { useCallback, useEffect, useState, useContext } from "react";
import { BsArrowDown } from "react-icons/bs";
import { Col, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import _, { isEmpty } from "lodash";
import ButtonPermission from "../../../components/UI/Button/ButtonPermission";
import TextSpinner from "../../../components/UI/Spinner/TextSpinner";
import funcionalidades from "../../../context/AuthContext.funcionalidades";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import useSolicitarProrrogacao from "./hooks/useSolicitarProrrogacao";
import useColumns from "./hooks/useColumns";
import { AuthContext } from "../../../context/AuthContext";
import ProrrogacaoOsDetalhes from "./components/ProrrogacaoOsDetalhes";
import useResponsabilidadeOrgao from "../ExecutarOrdemServico/hooks/useResponsabilidadeOrgao";
import OsContext from "../../../context/OsContext";
import constants from "../../Constants";

const ProrrogacaoOs = ({ dadosOs, diasExpirar, history }) => {
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [pageNumber, setPageNumber] = useState(1);
  const setSelection = useState({})[1];
  const [totalProrrogados, setTotalProrrogados] = useState(0);
  const [pedidoProrrogacao, setPedidoProrrogacao] = useState(null);
  const { columns } = useColumns();
  const { request, data, errors, isLoading } = useApiClient();
  const { user } = useContext(AuthContext);
  const { responsabilidadeOrgao } = useResponsabilidadeOrgao(user.codigo);

  const [caminhoHistory, setCaminhoHistory] = useState({});

  const handlePageChange = useCallback((newPageNumber) => {
    setPageNumber(newPageNumber);
  }, []);

  const handlePerRowsChange = useCallback((newPageSize) => {
    setPageSize(newPageSize);
    setPageNumber(1);
  }, []);

  const requestDadosOsHandler = useCallback(() => {
    if (dadosOs.acaoFiscal !== "" || dadosOs.acaoFiscal !== undefined) {
      const values = {
        acaoFiscal: dadosOs.acaoFiscal,
        pageSize,
        pageNumber,
      };

      request(apiRoutes.fiscalizacao.prorrogacaoos.prorrogacaoOs, values);
    }
  }, [request, dadosOs.acaoFiscal, pageSize, pageNumber]);

  const { solicitarProrrogacao, solicitarProrrogacaoShow, setSolicitarProrrogacaoShow, setGuardClient } =
    useSolicitarProrrogacao({
      dadosOs,
      pedidoProrrogacao,
      onUpdate: requestDadosOsHandler,
    });
  useEffect(() => {
    requestDadosOsHandler();
  }, [requestDadosOsHandler, setSolicitarProrrogacaoShow]);

  useEffect(() => {
    if (data?.result) {
      const pedidoEmAnalise = data.result.find((item) => item.situacaoPedido === "Salvo");
      setPedidoProrrogacao(pedidoEmAnalise ?? {});

      if (pedidoEmAnalise) {
        setSolicitarProrrogacaoShow(true);
      }

      const rowFilter = data.result.filter((item) => item.situacaoPedido !== "Salvo");

      setRows(rowFilter.map((item) => ({ ...item, dadosOs })));
      setTotalRows(rowFilter.length ? rowFilter[0].totalRows : 0);
      setTotalProrrogados(_.sum(rowFilter.map((item) => item.qtdDiasProrrogados)));
    }

    if (errors) {
      toast.error(errors.message);
    }
  }, [data, errors, setSolicitarProrrogacaoShow, totalProrrogados, dadosOs]);

  const SolicitarProrrogarOs = () => {
    if (!dadosOs.dataFinalPeriodoOs) {
      toast.error("Não é possível solicitar prorrogação, pois a OS ainda não está vigente.");
      return;
    }

    if (diasExpirar > 10) {
      toast.error("Não é possível solicitar prorrogação faltando mais de 10 dias para o término da OS.");
      return;
    }

    if (dadosOs.qntProrrogacoesAbertas > 0) {
      toast.error("Não é possível solicitar prorrogação quando já existe um pedido de prorrogação a ser homologado.");
      return;
    }

    setSolicitarProrrogacaoShow(true);
  };
  const { sequencial, acaoFiscal, inscricaoEstadual, cnpjCpf } = dadosOs;
  useEffect(() => {
    setCaminhoHistory({
      ...history,
      nuOrdemServico: sequencial,
      sqAcaoFiscal: acaoFiscal,
      inscricaoestadual: inscricaoEstadual,
      cnpj: cnpjCpf,
    });
  }, [history, sequencial, acaoFiscal, inscricaoEstadual, cnpjCpf]);

  const { location } = history;
  const { pathname } = location;

  const caminho = pathname === "/app/os/consultarOs/consulta";

  const conditionalRowStyles = [
    {
      when: (row) => row.situacaoProrrogacao === "Cancelado",
      style: { cursor: "not-allowed" },
    },
  ];

  return (
    <OsContext.Provider value={caminhoHistory}>
      <>
        {setGuardClient.guardLink}

        <div style={{ width: "100%" }}>
          <Row
            style={{ marginBottom: 20, textAlign: "right" }}
            hidden={solicitarProrrogacaoShow || responsabilidadeOrgao !== "F"}
          >
            <Col>
              {(diasExpirar < 10 || diasExpirar === "") && dadosOs?.qntProrrogacoesAbertas < 1 && !caminho && (
                <ButtonPermission
                  className="mr-0 btn btn-primary btn-md btn-user"
                  name="Solicitar Prorrogação"
                  permission={funcionalidades.os.ProrrogacaoAndamento}
                  onClick={() => SolicitarProrrogarOs()}
                />
              )}
              {dadosOs.qntProrrogacoesAbertas > 0 && (
                <p style={{ color: "red", marginBottom: 0 }}>
                  Não é possível solicitar prorrogação quando já existe um pedido de prorrogação a ser analisado.
                </p>
              )}

              {diasExpirar > 10 && (
                <p style={{ color: "red" }}>
                  Não é possível solicitar prorrogação faltando mais de 10 dias úteis para o término da OS.
                </p>
              )}
            </Col>
          </Row>

          {(pedidoProrrogacao?.situacaoPedido === "Salvo" || isEmpty || rows.length > 0) &&
            responsabilidadeOrgao === "F" &&
            solicitarProrrogacao}

          {!solicitarProrrogacaoShow ? (
            <Row>
              <Col>
                <DataTable
                  noHeader
                  keyField="sqAndamento"
                  columns={columns}
                  data={rows}
                  progressPending={isLoading}
                  noDataComponent="Não há pedidos de prorrogação para esta OS ou há pedidos com pendência de assinatura."
                  progressComponent={<TextSpinner />}
                  defaultSortFieldId={1}
                  sortIcon={<BsArrowDown />}
                  expandableRows={!!rows.length}
                  expandableRowsComponent={ProrrogacaoOsDetalhes}
                  // expandableRowDisabled={(row) => row.disabled}
                  expandableRowDisabled={(row) => row.situacaoProrrogacao === "Cancelado" || row.disabled}
                  pagination
                  paginationServer
                  sortable
                  conditionalRowStyles={conditionalRowStyles}
                  paginationTotalRows={totalRows}
                  onSelectedRowsChange={(state) => {
                    setSelection(state.selectedRows);
                  }}
                  pointerOnHover
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  paginationComponentOptions={constants.paginationComponentOptions}
                  paginationPerPage={pageSize}
                />
                {totalProrrogados > 0 && rows.situacaoProrrogacao === "S" && (
                  <h5 style={{ marginTop: -55, marginLeft: 15 }}>{`Total de dias Prorrogados: ${totalProrrogados}`}</h5>
                )}
              </Col>
            </Row>
          ) : (
            <p style={{ color: "red", textAlign: "right" }}>
              {responsabilidadeOrgao !== "F" &&
                "Não há pedidos de prorrogação para esta OS ou há pedidos com pendência de assinatura."}
            </p>
          )}
        </div>
      </>
    </OsContext.Provider>
  );
};

export default ProrrogacaoOs;
